<template>
    <div class="container doubts-container adminWeeducCreateCourse" data-aos="fade-left" data-aos-duration="1500">
        <div class="titleContainer myCoursesWeeduc">
            <h3>Novo Curso</h3>
            <p style="font-size: 14px;margin-bottom: 0;">Crie as informações básicas do seu curso. Após salvar, você poderá personalizar e criar os módulos e atividades.</p>
        </div>

        <div class="form-container">
            <div class="form-row new-course">
                <div class="form-group col-6">
                    <div class="form-group col-12">
                        <p class="form-label-title">Nome do curso*</p>
                        <div class="form-input">
                            <input 
                                type="text"
                                class="form-control"
                                v-model="courseData.courseName"
                                placeholder="Digite o nome do curso"
                                required
                                @input="updateCourseUrl"
                            />
                        </div>
                    </div>

                    <div class="form-group col-12">
                        <p class="form-label-title">Nome do comercial*</p>
                        <div class="form-input">
                            <input 
                                type="text"
                                class="form-control"
                                v-model="courseData.commercialName"
                                placeholder="Digite o nome do comercial"
                                required
                            />
                        </div>
                    </div>
                    
                    <div class="form-row status-price" style="display: flex; flex-wrap: wrap; gap: 10px; align-items: flex-end;">
                        <div class="form-group col-12 stuatus">
                            <p class="form-label-title">Status*</p>
                            <div class="form-input">
                                <select class="form-control" v-model="courseData.courseStatus" required>
                                    <option value="1">Ativo</option>
                                    <option value="2">Apenas matrículas internas</option>
                                    <option value="3">Em Espera</option>
                                    <option value="4">Inativo</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group col-1 price" style="min-width: 140px;">
                            <p class="form-label-title">Preço</p>
                            <div class="form-input">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">R$</span>
                                    </div>
                                    <input 
                                        type="text"
                                        class="form-control price-input"
                                        :value="courseData.coursePrice ? courseData.coursePrice.toString().replace('.', ',') : ''"
                                        placeholder="0,00"
                                        required
                                        pattern="[0-9,]*"
                                        inputmode="decimal"
                                        @input="formatPrice"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-1 discount" style="min-width: 140px;">
                            <p class="form-label-title">Desconto</p>
                            <div class="form-input">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">R$</span>
                                    </div>
                                    <input 
                                        type="text"
                                        class="form-control price-input"
                                        :value="courseData.discountAmount ? courseData.discountAmount.toString().replace('.', ',') : ''"
                                        placeholder="0,00"
                                        required
                                        pattern="[0-9,]*"
                                        inputmode="decimal"
                                        @input="formatDiscount"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-1" style="min-width: 140px;">
                            <p class="form-label-title">Valor Final*</p>
                            <div class="form-input">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">R$</span>
                                    </div>
                                    <input 
                                        type="text"
                                        class="form-control price-input"
                                        :value="(courseData.coursePrice - courseData.discountAmount).toFixed(2).replace('.', ',')"
                                        placeholder="0,00"
                                        readonly
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-12">
                        <p class="form-label-title">Url do curso*</p>
                        <div class="form-input">
                            <input 
                                type="text"
                                class="form-control"
                                v-model="courseData.courseUrl"
                                placeholder="Digite a URL do curso"
                                required
                            />
                        </div>
                    </div>
                    <div class="form-group col-12">
                        <label class="form-label-title">Descrição</label>
                        <div class="form-input">
                            <textarea
                                class="form-control"
                                v-model="courseData.courseDescription" 
                                placeholder="Adicione informações e detalhes sobre o curso"
                                rows="4"
                            ></textarea>
                        </div>
                    </div>

                    <div class="form-group col-12">
                        <label class="form-label-title">Descrição Completa</label>
                        <div class="form-input">
                            <textarea
                                class="form-control"
                                v-model="courseData.longDescription" 
                                placeholder="Adicione uma descrição completa sobre o curso"
                                rows="4"
                            ></textarea>
                        </div>
                    </div>
                </div>

                <div class="form-group col-6">
                  
                    <div class="form-group col-12" style="display: flex; align-items: flex-end; gap: 16px;">
                        <div class="form-input" :style="(courseData.approvalEnabled === true || courseData.approvalEnabled === 'true') ? 'width: 50%;' : 'width: 100%;'">
                            <p class="form-label-title">Habilitar aprovação com nota?</p>
                            <select class="form-control" v-model="courseData.approvalEnabled" :disabled="showImportedQuestions" required>
                                <option :value="true">Ativo</option>
                                <option :value="false">Inativo</option>
                            </select>
                        </div>
                        <div v-if="courseData.approvalEnabled === true || courseData.approvalEnabled === 'true'" class="form-input" style="width: 50%;">
                            <p class="form-label-title">Nota mínima para aprovação</p>
                            <select class="form-control" v-model="courseData.minGrade" required>
                                <option v-for="n in 11" :key="n-1" :value="n-1">{{ n-1 }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group col-12" style="display: flex; align-items: flex-end; gap: 16px;">
                        <div class="form-input" :style="courseData.certificateEnabled === true || courseData.certificateEnabled === 'true' ? 'width: 50%;' : 'width: 100%;'">
                            <p class="form-label-title">Certificado</p>
                            <select class="form-control" v-model="courseData.certificateEnabled" required>
                                <option :value="true">Ativo</option>
                                <option :value="false">Inativo</option>
                            </select>
                        </div>
                        <div v-if="courseData.certificateEnabled === true || courseData.certificateEnabled === 'true'" class="form-input" style="width: 50%;">
                            <p class="form-label-title">Tipo de Certificado</p>
                            <select class="form-control" v-model="courseData.certificateType" required>
                                <option value="certificado1">Certificado Padrão</option>
                                <option value="certificado2">Certificado Avançado</option>
                                <option value="certificado3">Certificado Especial</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group col-12">
                        <p class="form-label-title">Prazo para Disponibilidade</p>
                        <div class="form-input">
                            <select class="form-control" v-model="courseData.availabilityDeadline" required>
                                <option value="vitalicio">Vitalício</option>
                                <option value="1ano">1 Ano</option>
                                <option value="6meses">6 Meses</option>
                                <option value="3meses">3 Meses</option>
                                <option value="1mes">1 Mês</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group col-12">
                        <p class="form-label-title">Capa do Produto - Principal</p>
                        <div class="form-file">
                            <div class="file-wrapper primary">
                                <span class="thumbnail thumb-img">
                                    <img v-if="imagePreviewCover" :src="imagePreviewCover" class="preview-image" />
                                    <span class="icon" v-if="loaderImage && !imagePreviewCover">
                                        <svg width="46" height="39" viewBox="0 0 46 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501" stroke="#9D9FA3" stroke-width="1.25714"></path>
                                            <rect x="1.00049" y="1.40454" width="43.9461" height="36.1909" rx="2.58507" stroke="#9D9FA3" stroke-width="1.25714"></rect>
                                            <circle cx="14.8948" cy="10.6676" r="3.71629" stroke="#9D9FA3" stroke-width="1.25714"></circle>
                                        </svg>
                                    </span>
                                    <span class="text" v-if="loaderImage && !imagePreviewCover">
                                        Clique aqui para selecionar a imagem
                                    </span>
                                    <LoaderImage :hasReady="loaderImage"/>
                                </span>
                                <input class="form-control" type="file" @change="updateFileCover" accept=".png, .jpg, .jpeg, .webp"/>
                            </div>
                            <div class="form-caption">
                                <div class="caption">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-12">
                        <p class="form-label-title">Capa do Produto - Thumbnail</p>
                        <div class="form-file">
                            <div class="file-wrapper primary">
                                <span class="thumbnail thumb-img">
                                    <img v-if="imagePreviewCover2" :src="imagePreviewCover2" class="preview-image" />
                                    <span class="icon" v-if="loaderImage2 && !imagePreviewCover2">
                                        <svg width="46" height="39" viewBox="0 0 46 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501" stroke="#9D9FA3" stroke-width="1.25714"></path>
                                            <rect x="1.00049" y="1.40454" width="43.9461" height="36.1909" rx="2.58507" stroke="#9D9FA3" stroke-width="1.25714"></rect>
                                            <circle cx="14.8948" cy="10.6676" r="3.71629" stroke="#9D9FA3" stroke-width="1.25714"></circle>
                                        </svg>
                                    </span>
                                    <span class="text" v-if="loaderImage2 && !imagePreviewCover2">
                                        Clique aqui para selecionar a imagem
                                    </span>
                                    <LoaderImage :hasReady="loaderImage2"/>
                                </span>
                                <input class="form-control" type="file" @change="updateFileCover2" accept=".png, .jpg, .jpeg, .webp"/>
                            </div>
                            <div class="form-caption">
                                <div class="caption">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>          

            <div class="button-container">
                <button class="btn-weflix default" @click="$router.go(-1)">Cancelar</button>
                <button class="btn-weflix primary default" @click="saveCourse">Salvar</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import LoaderImage from '@/components/Weflix/LoaderImage';
import apiAWS from '@/utils/storage/aws';
import apiCourses from '@/utils/courses';
import { toast } from 'vue3-toastify';

export default {
    data() {
        return {
            courseData: {
                courseName: '',
                coursePrice: null,
                courseStatus: '1',
                courseDescription: '',
                coverImage: null,
                thumbnailImage: null,
                availabilityDeadline: 'vitalicio',
                commercialName: '',
                courseUrl: '',
                approvalEnabled: false,
                approvalCriteria: '',
                discountAmount: 0,
                certificateEnabled: false,
                certificateId: 1,
                longDescription: ''
            },
            loaderImage: true,
            loaderImage2: true,
            imagePreviewCover: null,
            imagePreviewCover2: null,
            coverVideo: null,
            coverVideo2: null,
            oldCourseName: ''
        }
    },
    computed: {
        ...mapState(['token'])
    },
    created() {
        console.log('Token no created:', this.token)
    },
    methods: {
        ...mapActions(['storeCurrentCollections']),

        formatPrice(event) {
            let value = event.target.value.replace(/\D/g, '')
            value = (Number(value) / 100).toFixed(2)
            this.courseData.coursePrice = value
        },
        formatDiscount(event) {
            let value = event.target.value.replace(/\D/g, '')
            value = (Number(value) / 100).toFixed(2)
            this.courseData.discountAmount = value
        },
        updateCourseUrl() {
            const formattedUrl = this.courseData.courseName
                .toLowerCase()
                .normalize("NFD").replace(/[\u0300-\u036f]/g, '')
                .replace(/ç/g, 'c')
                .replace(/[^a-z0-9\s]/g, '')
                .replace(/\s+/g, '-')
                .trim();

            this.courseData.courseUrl = formattedUrl;
        },
        async saveCourse() {
            const payload = {
                name: this.courseData.courseName,
                price: this.courseData.coursePrice,
                status: this.courseData.courseStatus,
                description: this.courseData.courseDescription,
                coverImage: this.coverVideo,
                thumbnailImage: this.coverVideo2,
                certificate: 0,
                comercialName: this.courseData.commercialName,
                url: this.courseData.courseUrl,
                shortDescription: this.courseData.courseDescription,
                longDescription: this.courseData.longDescription,
                imagePath: this.coverVideo,
                imagePath2:this.coverVideo2,
                dayExpired: 0,
                approved: 0,
                installment: 0,
                order: 0,
                discount: this.courseData.discountAmount
            }
            
            try {
                if (!this.courseData.courseName || !this.courseData.coursePrice) {
                    this.notify('Por favor, preencha todos os campos obrigatórios', 'error');
                    return  
                }
                const response = await apiCourses.createNewCourse(payload, this.token);
                console.log(response);
                this.storeCurrentCollections({currentCollections: response});
                this.$router.push({
                    path: '/dashboard/curso',
                    query: { toast: 'Curso criado com sucesso!' }
                });
            } catch (error) {
                console.error('Erro ao salvar curso:', error)
            }
        },
        async putFileAws(url, file){
            try {
                const response = await apiAWS.putFileAWS(url, file);
                return response;
            } catch (error) {
                console.error('Erro ao enviar arquivo para AWS');
            }
        },
        async updateFileCover(event){
            this.loaderImage = false;
            const file = event.target.files[0];
            this.imagePreviewCover = URL.createObjectURL(file);
            try {
                const response = await apiAWS.getSignatureImage(this.token, file.name);
                await this.putFileAws(response.url, file);
                this.coverVideo = response.token;
                this.loaderImage = true;
            } catch (error) {
                console.error('Erro na geração do TOKEN AWS')
            }
        },
        async updateFileCover2(event){
            this.loaderImage2 = false;
            const file = event.target.files[0];
            this.imagePreviewCover2 = URL.createObjectURL(file);
            try {
                const response = await apiAWS.getSignatureImage(this.token, file.name);
                await this.putFileAws(response.url, file);
                this.coverVideo2 = response.token;
                this.loaderImage2 = true;
            } catch (error) {
                console.error('Erro na geração do TOKEN AWS')
            }
        },
        notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: "light", 
                limit: 1,
                type: type,
                dangerouslyHTMLString: true
            });
        },
    },
    watch: {
        'courseData.courseName'(newVal) {
            const commercial = this.courseData.commercialName;
            if (!commercial || commercial === this.oldCourseName) {
            this.courseData.commercialName = newVal;
            }
            this.oldCourseName = newVal;
        }
    }
}
</script>

<style>
@import '@/css/weeduc/admin/createCourse.css';
</style>
